import React, { Component } from 'react'
import { Container, Grid, Image, Segment } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { ssoLogin } from '../../actions';

class AdminRedirectPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        }
    }

    componentDidMount() {
        let queryString = new URLSearchParams(this.props.history.location.search);
        const tokenId = queryString.get("token")

        if(tokenId){
            this.props.ssoLogin(tokenId, (result, error) => {
                setTimeout( () => {
                    if(result) {
                        this.props.history.push('/systemadmin');
                    }
                    
                    if(error){
                        this.setState({
                            error: error.errorMessage
                        })
                    }
                }, 3000)
            })
        }
    }

    render() {
        return (
            <Container style={{ paddingTop: '25vh' }}>
                <Grid centered>
                    <Segment padded='very'>
                        <Image src="/groupcare_logo_hor.jpg" size="small" centered alt='groupcare'/>
                        { !this.state.error && 
                        <div style={{paddingTop: 50}}>
                            <p>
                                You're being redirected to another page,
                            </p>
                            <p>
                                it may take a while
                            </p>
                        </div> }
                        { this.state.error && 
                        <div style={{paddingTop: 50}}>
                        <p>
                            {this.state.error}
                        </p>
                        </div> }
                    </Segment>
                </Grid>
           </Container>
        );
    }
}

export default connect(null, { ssoLogin })(AdminRedirectPage);
